// src/pages/grupos/ConvidarMembros.jsx

import { useState, useRef, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import api from "../../services/api";

export default function ConvidarMembros() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [emailBusca, setEmailBusca] = useState("");
  const [resultado, setResultado] = useState(null);
  const [erro, setErro] = useState("");
  const [loadBusca, setLoadBusca] = useState(false);

  const [mensagem, setMensagem] = useState("");
  const [userSelecionado, setUserSelecionado] = useState(null);

  const [loadConvite, setLoadConvite] = useState(false);

  const modalRef = useRef(null);
  const modalObjRef = useRef(null);

  // ===========================================================
  //   CRIAÇÃO ÚNICA DO MODAL (evita múltiplos backdrops)
  // ===========================================================
  useEffect(() => {
    if (modalRef.current) {
      modalObjRef.current = new window.bootstrap.Modal(modalRef.current, {
        backdrop: true,
        keyboard: true
      });
    }
  }, []);

  // ===========================================================
  //   ABRIR MODAL (não cria modal novamente)
  // ===========================================================
  const abrirModal = (user) => {
    setUserSelecionado(user);
    setErro("");
    setMensagem("");

    if (modalObjRef.current) {
      modalObjRef.current.show();
    }
  };

  // ===========================================================
  //   FECHAR MODAL (remove backdrop preso e restaura o body)
  // ===========================================================
  const fecharModal = () => {
    if (modalObjRef.current) {
      modalObjRef.current.hide();

      // Remove backdrops duplicados
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());

      // Remove estados travados do body
      document.body.classList.remove("modal-open");
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("padding-right");
    }
  };

  // ===========================================================
  //   BUSCAR USUÁRIO
  // ===========================================================
  const buscarUsuario = async () => {
    if (!emailBusca.trim()) {
      setErro("Digite um e-mail para buscar.");
      return;
    }

    setErro("");
    setResultado(null);
    setLoadBusca(true);

    try {
      const r = await api.get(`/grupos/${id}/buscar-usuarios/?q=${emailBusca}`);
      setResultado(r.data);
    } catch (e) {
      setErro("Erro ao buscar usuário.");
    } finally {
      setLoadBusca(false);
    }
  };

  // ===========================================================
  //   ENVIAR CONVITE
  // ===========================================================
  const enviarConvite = async () => {
    if (!userSelecionado) return;

    setLoadConvite(true);
    setErro("");

    try {
      await api.post(`/grupos/${id}/convidar/`, {
        destinatario: userSelecionado.id,
        mensagem,
      });

      fecharModal();

      // Delay mínimo para garantir que o backdrop foi removido:
      setTimeout(() => {
        navigate(`/grupos/${id}`);
      }, 150);

    } catch (e) {
      setErro(e.response?.data?.detail || "Erro ao enviar convite.");
    } finally {
      setLoadConvite(false);
    }
  };

  // ===========================================================
  //   RENDER
  // ===========================================================
  return (
    <>
      <Navbar />

      <div className="container mt-4">

        {/* Título principal */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="fw-bold mb-0">Convidar membros</h2>

          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => navigate(`/grupos/${id}`)}
          >
            Voltar ao grupo
          </button>
        </div>

        <div className="card shadow-sm p-4">

          <h5 className="fw-bold mb-3">Buscar usuário pelo e-mail</h5>

          {/* Campo de busca */}
          <div className="input-group mb-3">
            <input
              type="email"
              className="form-control"
              placeholder="Digite o e-mail do usuário"
              value={emailBusca}
              onChange={(e) => setEmailBusca(e.target.value)}
            />

            <button
              className="btn btn-primary"
              onClick={buscarUsuario}
              disabled={loadBusca}
            >
              {loadBusca ? "Buscando..." : "Buscar"}
            </button>
          </div>

          {erro && <div className="alert alert-danger">{erro}</div>}

          {/* Resultados da busca */}
          {Array.isArray(resultado) && resultado.length > 0 && (
            <>
              <h5 className="fw-bold mt-4">Resultados</h5>

              <ul className="list-group mt-2">
                {resultado.map((u) => (
                  <li
                    key={u.id}
                    className="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <div className="fw-bold">{u.nome}</div>
                      <small className="text-muted">{u.email}</small>
                    </div>

                    <button
                      className="btn btn-success btn-sm"
                      onClick={() => abrirModal(u)}
                    >
                      Convidar
                    </button>
                  </li>
                ))}
              </ul>
            </>
          )}

          {/* Nenhum resultado */}
          {resultado && !Array.isArray(resultado) && (
            <div className="alert alert-info mt-3">
              {resultado.detail}
            </div>
          )}

        </div>
      </div>

      {/* MODAL DE CONFIRMAÇÃO */}
      <div
        className="modal fade"
        id="modalConfirmarConvite"
        ref={modalRef}
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Confirmar convite</h5>
              <button
                type="button"
                className="btn-close"
                onClick={fecharModal}
              />
            </div>

            <div className="modal-body">

              {userSelecionado && (
                <>
                  <p>
                    Deseja enviar um convite para:
                    <br />
                    <strong>{userSelecionado.nome}</strong>
                    <br />
                    <small className="text-muted">{userSelecionado.email}</small>
                  </p>

                  <label className="form-label fw-bold mt-3">
                    Mensagem opcional
                  </label>

                  <textarea
                    className="form-control"
                    rows="3"
                    value={mensagem}
                    onChange={(e) => setMensagem(e.target.value)}
                    placeholder="Digite uma mensagem (opcional)"
                  />

                  {erro && (
                    <div className="alert alert-danger mt-3">{erro}</div>
                  )}
                </>
              )}

            </div>

            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={fecharModal}
                disabled={loadConvite}
              >
                Cancelar
              </button>

              <button
                className="btn btn-success"
                onClick={enviarConvite}
                disabled={loadConvite}
              >
                {loadConvite ? "Enviando..." : "Enviar convite"}
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}
